import { z } from 'zod';

// Schemas (source of truth) — pure validation, no transforms
export const defaultCertificateSchema = z.object({
	_id: z.string().optional(),
	name: z.string(),
	groupName: z.string(),
	isCommonlyUsed: z.boolean(),
	language: z.string(),
});

// Types (derived from schemas)
export type IDefaultCertificate = z.infer<typeof defaultCertificateSchema>;
